import React from 'react';
import './SetupPage.css';
import { setupSections } from '../../data/setupData';
import PageHeader from '../../components/PageHeader/PageHeader';

function SetupPage() {
  return (
    <div className="page-bg-overlay">
      <main className="page-container setup-page-container">
        <PageHeader
          eyebrow="Setup"
          title="O meu setup"
          subtitle="Especificações do PC e periféricos usados na stream."
        />

        <section className="setup-grid">
          {setupSections.map((section) => (
            <article key={section.id} className="setup-card">
              <h2 className="setup-card-title">{section.title}</h2>
              <ul className="setup-list">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <span className="label">{item.label}</span>
                    <span className="value">{item.value}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>
      </main>
    </div>
  );
}

export default SetupPage;
